import type { ICategory } from "app/common/services/categoryService.types";
import type { ICountry } from "app/components/filters-bar/country-filter/CountryFilterTypes";
import * as utils from "app/components/filters-bar/utils";
import type { IDomains } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";
import CountryService from "app/services/CountryService";
import { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

const getDomains = (categoryObject: ICategory): IDomains => {
    if (!categoryObject || !categoryObject.domains) {
        return [];
    }
    return categoryObject.domains.map((domain) => ({
        domain,
        id: domain,
        type: EAssetType.Website,
    }));
};

const getCountry = (categoryObject: ICategory): ICountry => {
    if (!categoryObject) {
        return utils.getCountries()[0];
    }
    const country = categoryObject.country
        ? CountryService.getCountryById(categoryObject.country)
        : utils.getCountries()[0];
    return country;
};

export const getCategoryData = (categoryObject: ICategory) => {
    if (!categoryObject) {
        return {
            segments: [],
            domains: [],
            country: utils.getCountries()[0],
        };
    }

    const { segments = [] } = categoryObject;
    const domains = getDomains(categoryObject);
    const country = getCountry(categoryObject);
    return { domains, country, segments };
};
